/*! @azure/msal-common v15.2.0 2025-02-18 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const cacheQuotaExceededErrorCode = "cache_quota_exceeded";
const cacheUnknownErrorCode = "cache_error_unknown";

export { cacheQuotaExceededErrorCode, cacheUnknownErrorCode };
//# sourceMappingURL=CacheErrorCodes.mjs.map
